export const optionsFilters = (group, option, isChecked, selectedFilters) => {
	console.log('addFilters', selectedFilters);
	let newFilters = [...selectedFilters];
	if (isChecked === true) {
		newFilters = [...selectedFilters, { group, option, isChecked }];
	}

	if (isChecked === false) {
		newFilters = selectedFilters.filter((filter) => filter.option !== option);
	}

	return newFilters;
};
